module.exports = __webpack_public_path__ + "static/img/chanta (7).0918dd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chanta/chanta (7).jpg
// module id = rBhx
// module chunks = 0